module.exports = __webpack_public_path__ + "img/new_ch_tab_bg1.b4be0f2a.png";